/**
 * Where a stored offline row says its tenant is, in ONE place (round 7 L3): the send gate
 * (client-id.ts sendDeferral) and the tenant wipe (terminal-auth.ts) both read it here.
 * A row may name its tenant in its originator stamp (origin_tenant_id), its own tenant_id,
 * or, for a cached server copy, the copy's data.tenant_id. Empty values do not count.
 * Deliberately free of imports: the API client loads terminal-auth eagerly.
 */
export function rowTenantsOf(row: unknown): string[] {
  if (!row || typeof row !== 'object') return [];
  const r = row as { tenant_id?: unknown; origin_tenant_id?: unknown; data?: unknown };
  const out: string[] = [];
  const add = (v: unknown) => {
    if (typeof v === 'string' && v.length > 0 && !out.includes(v)) out.push(v);
  };
  add(r.origin_tenant_id);
  add(r.tenant_id);
  if (r.data && typeof r.data === 'object') add((r.data as { tenant_id?: unknown }).tenant_id);
  return out;
}
